// libraries
import clsx from 'clsx'

// components
import HeroSingleCourse, { HeroSingleCourseProps } from '/react4xp/components/HeroSingleCourse'
import Section from '/react4xp/components/Section'
import Highlights from '/react4xp/components/Highlights'
import RichText from '/react4xp/components/RichText'
import EntryCard, { EntryCardProps } from '/react4xp/components/EntryCard'
import StudyProgress, { StudyProgressDetails, StudyProgressSingleStrings } from '/react4xp/components/StudyProgress'
import StudyProgressTabs, { StudyProgressTab } from '/react4xp/components/StudyProgressTabs'
import ContentBox, { ContentBoxProps } from '/react4xp/components/ContentBox'

// types
interface SingleCourseProps {
    className?: string
    hero?: HeroSingleCourseProps
    highlights?: {
        title?: string
        description?: string
    }[]
    richText?: string
    entryCard?: EntryCardProps
    studyProgress?: {
        title?: string
        details?: StudyProgressDetails[]
        singleStrings?: StudyProgressSingleStrings
    }
    studyModelTabs?: StudyProgressTab[] | null
    moreInformation?: {
        title?: string
        description?: string
        cta?: {
            label?: string
            url?: string
            external?: boolean
        }[]
    }
    contentBox?: ContentBoxProps
    internalRegion?: any
    bottomRegion?: any
}

// css
import './index.scss'

export default function SingleCourse({
    className,
    hero,
    highlights,
    richText,
    entryCard,
    studyProgress,
    studyModelTabs,
    contentBox,
    internalRegion,
    bottomRegion
}: SingleCourseProps) {
    const hasTabs = Array.isArray(studyModelTabs) && studyModelTabs.length > 1
    return (
        <div className={clsx('page-course-plan', className)}>

            {hero && (
                <HeroSingleCourse
                    image={{
                        src: hero?.image?.src,
                        srcSmall: hero?.image?.srcSmall,
                        alt: hero?.image?.alt
                    }}
                    title={hero?.title}
                    description={hero?.description}
                    course={hero?.course}
                    location={hero?.location}
                    duration={hero?.duration}
                    cost={hero?.cost}
                    requirements={hero?.requirements}
                    apply={hero?.apply}
                />
            )}

            {highlights && (
                <Highlights items={highlights} />
            )}

            {richText && (
                <Section
                    className='page-course-plan__rich-text'
                    removeMarginTop
                >
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-10 offset-lg-1 col-xl-6 offset-xl-3'>
                                <RichText>
                                    {richText}
                                </RichText>
                            </div>
                        </div>
                    </div>
                </Section>
            )}

            {entryCard && (
                <EntryCard
                    boxColor='green-light'
                    image={entryCard?.image}
                    title={entryCard?.title}
                    content={entryCard?.content}
                    cta={entryCard?.cta}
                />
            )}

            {internalRegion}

            {hasTabs ? (
                <StudyProgressTabs tabs={studyModelTabs!} />
            ) : (
                studyProgress && (
                    <StudyProgress
                        title={studyProgress?.title}
                        details={studyProgress?.details}
                        singleStrings={studyProgress?.singleStrings}
                    />
                )
            )}

            {contentBox && (
                <ContentBox
                    boxColor={contentBox?.boxColor}
                    title={contentBox?.title}
                    description={contentBox?.description}
                    cta={contentBox?.cta}
                />
            )}

            {bottomRegion}

        </div>
    )
}